// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SVGProps } from "react";

const WatchIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className={`min-icon`}
      fill={"currentcolor"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
    >
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h256v256H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <g transform="translate(4330.082 461.859)">
          <g data-name="Grupo 1495">
            <path
              data-name="Trazado 345"
              d="M-4235.5-461.859h-72.088a22.506 22.506 0 00-22.5 22.5V-365a5.2 5.2 0 005.2 5.2h7.578a5.209 5.209 0 005.219-5.2v-58.731a20.132 20.132 0 0120.125-20.133h56.461a5.2 5.2 0 005.2-5.2v-7.589a5.2 5.2 0 00-5.195-5.206z"
            />
            <path
              data-name="Trazado 345 - Contorno"
              d="M-4307.586-462.009h72.088a5.355 5.355 0 015.345 5.353v7.589a5.355 5.355 0 01-5.345 5.353h-56.461a19.834 19.834 0 00-7.771 1.57 19.914 19.914 0 00-6.35 4.281 19.912 19.912 0 00-4.283 6.352 19.858 19.858 0 00-1.571 7.78V-365a5.367 5.367 0 01-5.369 5.353h-7.578a5.358 5.358 0 01-5.351-5.353v-74.364a22.481 22.481 0 011.781-8.813 22.59 22.59 0 014.856-7.2 22.591 22.591 0 017.2-4.854 22.487 22.487 0 018.809-1.778zm72.088 18a5.055 5.055 0 005.045-5.053v-7.589a5.055 5.055 0 00-5.045-5.053h-72.088a22.185 22.185 0 00-8.693 1.756 22.287 22.287 0 00-7.1 4.79 22.282 22.282 0 00-4.792 7.1 22.181 22.181 0 00-1.758 8.7V-365a5.058 5.058 0 005.051 5.053h7.578a5.067 5.067 0 005.069-5.053v-58.731a20.158 20.158 0 011.595-7.9 20.214 20.214 0 014.347-6.447 20.216 20.216 0 016.445-4.346 20.135 20.135 0 017.888-1.593z"
            />
            <path
              data-name="Trazado 346"
              d="M-4096.572-461.859h-78.979a5.207 5.207 0 00-5.209 5.2v7.589a5.207 5.207 0 005.209 5.2h63.352a20.138 20.138 0 0120.135 20.133V-365a5.2 5.2 0 005.209 5.2h7.574a5.2 5.2 0 005.193-5.2v-74.364a22.492 22.492 0 00-22.484-22.495z"
            />
            <path
              data-name="Trazado 346 - Contorno"
              d="M-4175.551-462.009h78.979a22.478 22.478 0 018.811 1.78 22.558 22.558 0 017.194 4.854 22.568 22.568 0 014.851 7.2 22.5 22.5 0 011.779 8.813V-365a5.354 5.354 0 01-5.343 5.353h-7.574a5.362 5.362 0 01-5.359-5.353v-58.731a19.841 19.841 0 00-1.572-7.78 19.912 19.912 0 00-4.285-6.352 19.932 19.932 0 00-6.353-4.282 19.851 19.851 0 00-7.774-1.57h-63.352a5.362 5.362 0 01-5.359-5.353v-7.589a5.362 5.362 0 015.357-5.352zm96.27 102.063a5.054 5.054 0 005.043-5.053v-74.364a22.211 22.211 0 00-1.755-8.7 22.275 22.275 0 00-4.786-7.1 22.262 22.262 0 00-7.1-4.79 22.18 22.18 0 00-8.693-1.756h-78.979a5.062 5.062 0 00-5.059 5.053v7.589a5.062 5.062 0 005.059 5.053h63.352a20.15 20.15 0 017.891 1.593 20.226 20.226 0 016.448 4.346 20.222 20.222 0 014.35 6.447 20.142 20.142 0 011.6 7.9V-365a5.062 5.062 0 005.059 5.053z"
            />
            <path
              data-name="Trazado 347"
              d="M-4079.281-310.249h-7.574a5.2 5.2 0 00-5.209 5.2v61.06a20.146 20.146 0 01-20.135 20.141h-63.352a5.2 5.2 0 00-5.209 5.199v7.6a5.2 5.2 0 005.209 5.194h78.979a22.486 22.486 0 0022.484-22.5v-76.694a5.194 5.194 0 00-5.193-5.2z"
            />
            <path
              data-name="Trazado 347 - Contorno"
              d="M-4086.86-310.399h7.574a5.354 5.354 0 015.343 5.353v76.692a22.513 22.513 0 01-1.779 8.817 22.559 22.559 0 01-4.851 7.2 22.554 22.554 0 01-7.194 4.852 22.491 22.491 0 01-8.811 1.779h-78.979a5.357 5.357 0 01-5.359-5.344v-7.6a5.358 5.358 0 015.359-5.344h63.352a19.839 19.839 0 007.774-1.571 19.935 19.935 0 006.353-4.285 19.927 19.927 0 004.285-6.355 19.85 19.85 0 001.572-7.781v-61.063a5.362 5.362 0 015.361-5.35zm-9.717 104.39a22.189 22.189 0 008.693-1.755 22.259 22.259 0 007.1-4.788 22.258 22.258 0 004.786-7.1 22.222 22.222 0 001.755-8.7v-76.697a5.054 5.054 0 00-5.043-5.053h-7.574a5.062 5.062 0 00-5.059 5.053v61.06a20.15 20.15 0 01-1.6 7.9 20.236 20.236 0 01-4.35 6.45 20.227 20.227 0 01-6.448 4.349 20.134 20.134 0 01-7.891 1.595h-63.352a5.057 5.057 0 00-5.059 5.044v7.6a5.057 5.057 0 005.059 5.044z"
            />
            <path
              data-name="Trazado 348"
              d="M-4235.5-223.849h-56.461a20.14 20.14 0 01-20.125-20.141v-61.059a5.209 5.209 0 00-5.219-5.2h-7.578a5.2 5.2 0 00-5.2 5.2v76.692a22.5 22.5 0 0022.5 22.5h72.088a5.2 5.2 0 005.2-5.194v-7.6a5.2 5.2 0 00-5.205-5.198z"
            />
            <path
              data-name="Trazado 348 - Contorno"
              d="M-4235.5-205.709h-72.088a22.492 22.492 0 01-8.81-1.779 22.586 22.586 0 01-7.2-4.852 22.582 22.582 0 01-4.856-7.2 22.493 22.493 0 01-1.781-8.817v-76.692a5.358 5.358 0 015.351-5.353h7.578a5.367 5.367 0 015.369 5.353v61.06a19.866 19.866 0 001.571 7.781 19.935 19.935 0 004.283 6.355 19.921 19.921 0 006.35 4.285 19.821 19.821 0 007.771 1.571h56.461a5.351 5.351 0 015.345 5.344v7.6a5.351 5.351 0 01-5.344 5.344zm-89.383-104.39a5.058 5.058 0 00-5.051 5.053v76.692a22.192 22.192 0 001.758 8.7 22.266 22.266 0 004.792 7.1 22.28 22.28 0 007.1 4.788 22.2 22.2 0 008.693 1.755h72.088a5.05 5.05 0 005.045-5.044v-7.6a5.05 5.05 0 00-5.045-5.044h-56.461a20.121 20.121 0 01-7.888-1.595 20.218 20.218 0 01-6.445-4.349 20.228 20.228 0 01-4.347-6.45 20.166 20.166 0 01-1.595-7.9v-61.056a5.067 5.067 0 00-5.069-5.053z"
            />
          </g>
          <circle
            data-name="Elipse 56"
            cx={49.548}
            cy={49.548}
            r={49.548}
            transform="translate(-4251.625 -388.701)"
          />
          <path
            data-name="Elipse 56 - Contorno"
            d="M-4202.077-388.851a49.712 49.712 0 0119.345 95.491 49.712 49.712 0 01-38.693-91.585 49.387 49.387 0 0119.348-3.906zm0 99.1a49.412 49.412 0 0019.229-94.918 49.411 49.411 0 00-38.457 91.033 49.089 49.089 0 0019.228 3.882z"
          />
        </g>
      </g>
    </svg>
  );
};

export default WatchIcon;
